import ArticlePagingResultModelBase from '../_generated/modelBases/article-paging-result-model-base';

export default class ArticlePagingResultModel extends ArticlePagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
